import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const apiUrlUsers = `${process.env.REACT_APP_API_URL}/users`;
const apiUrlSectores = `${process.env.REACT_APP_API_URL}/section`;
const apiUrlAddresses = `${process.env.REACT_APP_API_URL}/addres`;
const apiUrlEmpresas = `${process.env.REACT_APP_API_URL}/empresas`;

const CreateUser = () => {
    const [usuario, setUsuario] = useState('');
    const [pass, setPass] = useState('');
    const [nombreuser, setNombreUser] = useState('');
    const [apellido, setApellido] = useState('');
    const [ubicacion, setUbicacion] = useState('');
    const [tipo, setTipo] = useState('user');
    const [sector, setSector] = useState('');
    const [sectores, setSectores] = useState([]);
    const [sede, setSede] = useState('');
    const [sedes, setSedes] = useState([]);
    const [empresa, setEmpresa] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const [todasLasSedes, setTodasLasSedes] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEmpresas = async () => {
            try {
                const response = await axios.get(apiUrlEmpresas);
                setEmpresas(response.data);
            } catch (error) {
                console.error('Error fetching empresas:', error);
            }
        };
        fetchEmpresas();
    }, []);

    useEffect(() => {
        const fetchSectores = async () => {
            try {
                const response = await axios.get(apiUrlSectores);
                setSectores(response.data);
            } catch (error) {
                console.error('Error fetching sectores:', error);
            }
        };
        fetchSectores();
    }, []);

    useEffect(() => {
        const fetchSedes = async () => {
            try {
                const response = await axios.get(apiUrlAddresses);
                const mapeadas = response.data.map(s => ({
                    id: String(s.id_direccion),
                    label: s.nombre_sede || `${s.direccion} - ${s.localidad}`,
                    direccion: s.direccion,
                    id_empresa: s.id_empresa
                }));
                setTodasLasSedes(mapeadas);
            } catch (error) {
                console.error('Error fetching sedes:', error);
            }
        };
        fetchSedes();
    }, []);

    useEffect(() => {
        if (empresa) {
            const sedesFiltradas = todasLasSedes.filter(s => String(s.id_empresa) === String(empresa));
            setSedes(sedesFiltradas);
            setSede('');
            setSector('');
        } else {
            setSedes([]);
            setSede('');
            setSector('');
        }
    }, [empresa, todasLasSedes]);

    useEffect(() => {
        if (sede) {
            const sedeObj = sedes.find(s => s.id === sede);
            if (sedeObj) {
                setUbicacion(sedeObj.direccion || sedeObj.label);
            }
        } else {
            setUbicacion('');
        }
    }, [sede, sedes]);

    const sectoresFiltrados = sede
        ? sectores.filter(sectorObj => sectorObj.id_sede != null && String(sectorObj.id_sede) === String(sede))
        : sectores;

    const store = async (e) => {
        e.preventDefault();

        if (!sede) {
            alert('⚠️ Selecciona una sede antes de guardar el usuario.');
            return;
        }

        setIsSubmitting(true);
        try {
            await axios.post(apiUrlUsers, {
                usuario, pass, nombreuser, apellido, ubicacion, tipo, sector,
                id_sede: Number(sede)
            });
            alert('✅ Usuario creado exitosamente');
            navigate('/admin/AbmUsuarios');
        } catch (error) {
            console.error('Error al crear el usuario:', error);
            alert('❌ Error al crear el usuario: ' + (error.response?.data?.error || error.message));
        } finally {
            setIsSubmitting(false);
        }
    };

    const Back = () => {
        navigate('/admin/AbmUsuarios');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-rose-50 py-8 px-4">
            <div className="max-w-3xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-t-2xl shadow-xl p-6 border-b-4 border-purple-500">
                    <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-br from-purple-500 to-pink-600 p-4 rounded-xl shadow-lg">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-800">Nuevo Usuario</h1>
                            <p className="text-gray-600 mt-1">Crea un nuevo usuario del sistema</p>
                        </div>
                    </div>
                </div>

                {/* Form */}
                <form onSubmit={store} className="bg-white rounded-b-2xl shadow-xl p-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Usuario */}
                        <div>
                            <label htmlFor="usuario" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-blue-600">👤</span>
                                Usuario
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                id="usuario"
                                type="text"
                                placeholder="Nombre de usuario"
                                value={usuario}
                                onChange={(e) => setUsuario(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        {/* Contraseña */}
                        <div>
                            <label htmlFor="pass" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-green-600">🔒</span>
                                Contraseña
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                id="pass"
                                type="password"
                                placeholder="Contraseña"
                                value={pass}
                                onChange={(e) => setPass(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        {/* Nombre */}
                        <div>
                            <label htmlFor="nombreuser" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-purple-600">📝</span>
                                Nombre
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                id="nombreuser"
                                type="text"
                                placeholder="Nombre"
                                value={nombreuser}
                                onChange={(e) => setNombreUser(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        {/* Apellido */}
                        <div>
                            <label htmlFor="apellido" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-pink-600">📝</span>
                                Apellido
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                id="apellido"
                                type="text"
                                placeholder="Apellido"
                                value={apellido}
                                onChange={(e) => setApellido(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800 placeholder-gray-400"
                            />
                        </div>

                        {/* Empresa */}
                        <div>
                            <label htmlFor="empresa" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-indigo-600">🏢</span>
                                Empresa
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                id="empresa"
                                value={empresa}
                                onChange={(e) => setEmpresa(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800"
                            >
                                <option value="">Seleccione una empresa</option>
                                {empresas.map(emp => (
                                    <option key={emp.id_empresa} value={emp.id_empresa}>
                                        {emp.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Sede */}
                        <div>
                            <label htmlFor="sede" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-cyan-600">📍</span>
                                Sede
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                id="sede"
                                value={sede}
                                onChange={(e) => setSede(e.target.value)}
                                disabled={!empresa}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <option value="">
                                    {!empresa ? 'Seleccione empresa primero' : 'Seleccione una sede'}
                                </option>
                                {sedes.map(s => (
                                    <option key={s.id} value={s.id}>{s.label}</option>
                                ))}
                            </select>
                        </div>

                        {/* Ubicación */}
                        <div className="md:col-span-2">
                            <label htmlFor="ubicacion" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-teal-600">🗺️</span>
                                Ubicación
                            </label>
                            <input
                                id="ubicacion"
                                type="text"
                                placeholder="Ubicación (derivada de sede)"
                                value={ubicacion}
                                readOnly
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 bg-gray-50 text-gray-600 cursor-not-allowed"
                            />
                        </div>

                        {/* Sector */}
                        <div>
                            <label htmlFor="sector" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-orange-600">🏛️</span>
                                Sector
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                id="sector"
                                value={sector}
                                onChange={(e) => setSector(e.target.value)}
                                disabled={!sede}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <option value="">
                                    {!sede ? 'Seleccione sede primero' : 'Seleccione un sector'}
                                </option>
                                {sectoresFiltrados.map((sectorObj, index) => (
                                    <option key={index} value={sectorObj.sector}>
                                        {sectorObj.sector}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Tipo de Usuario */}
                        <div>
                            <label htmlFor="tipo" className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                                <span className="text-amber-600">⭐</span>
                                Tipo de Usuario
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                id="tipo"
                                value={tipo}
                                onChange={(e) => setTipo(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all outline-none text-gray-800"
                            >
                                <option value="user">Usuario</option>
                                <option value="admin">Administrador</option>
                                <option value="invitado">Invitado</option>
                                <option value="direccion">Dirección</option>
                            </select>
                        </div>
                    </div>

                    {/* Botones */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t-2 border-gray-200">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-purple-700 hover:to-pink-700 transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                        >
                            {isSubmitting ? (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                    </svg>
                                    Guardando...
                                </span>
                            ) : (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Crear Usuario
                                </span>
                            )}
                        </button>

                        <button
                            type="button"
                            onClick={() => navigate('/admin/AbmUsuarios')}
                            disabled={isSubmitting}
                            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg shadow-md transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <span className="flex items-center justify-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                Cancelar
                            </span>
                        </button>
                    </div>
                </form>

                {/* Info adicional */}
                <div className="mt-6 bg-purple-50 border-l-4 border-purple-500 p-4 rounded-r-lg shadow-md">
                    <div className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="text-sm font-semibold text-purple-900">Flujo de creación</p>
                            <p className="text-sm text-purple-700 mt-1">
                                Primero selecciona la empresa, luego la sede y finalmente el sector. La ubicación se completará automáticamente.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateUser;
